import { useEffect, useState } from "react";
import api from "../lib/api";
import { apiError } from "../lib/auth";
import { useFlash } from "../lib/flash";

export default function SmsBillingSettings() {
  const flash = useFlash();
  const [v, setV] = useState(null);
  const [info, setInfo] = useState(null);
  const [errors, setErrors] = useState({});
  const load = () => api.get("/owner/sms-billing").then((r) => {
    setInfo(r.data);
    setV({ included: (r.data.next || r.data).included, extra_price: (r.data.next || r.data).extra_price });
  });
  useEffect(() => { load(); }, []);
  if (!v) return null;
  const save = async (e) => {
    e.preventDefault();
    setErrors({});
    try {
      const r = await api.put("/owner/sms-billing", { included: Number(v.included), extra_price: String(v.extra_price) });
      flash(r.data.flash);
      load();
    } catch (ex) {
      if (ex.response?.data?.errors) setErrors(ex.response.data.errors);
      else flash(apiError(ex.response?.data?.detail) || ex.message, "error");
    }
  };
  const field = (k, label, props) => (
    <div className="field">
      <label htmlFor={`sb-${k}`}>{label}</label>
      <input id={`sb-${k}`} value={v[k]} onChange={(e) => setV((o) => ({ ...o, [k]: e.target.value }))} aria-invalid={!!errors[k]} data-testid={`sms-billing-${k}`} {...props} />
      {errors[k] && <div className="bf-err">{errors[k]}</div>}
    </div>
  );
  return (
    <form className="bf-grid ss-grid" onSubmit={save} noValidate data-testid="sms-billing-settings" style={{ marginTop: 16 }}>
      <div style={{ gridColumn: "1 / -1" }}>
        <b>SMS pr. butik</b>
        <div className="hint" data-testid="sms-billing-current">
          Nu: {info.included} SMS inkluderet pr. måned, ekstra SMS {info.extra_price} kr. ekskl. moms.
          {info.next ? ` Fra 1. ${info.next.from}: ${info.next.included} SMS, ${info.next.extra_price} kr.` : ` Ændringer gælder fra 1. ${info.from_label}.`}
        </div>
      </div>
      {field("included", "Inkluderede SMS pr. måned", { type: "number", min: 0, inputMode: "numeric" })}
      {field("extra_price", "Pris pr. ekstra SMS (kr. ekskl. moms)", { inputMode: "decimal" })}
      <div className="bf-actions" style={{ gridColumn: "1 / -1" }}>
        <button className="btn" data-testid="sms-billing-save">Gem SMS-priser</button>
      </div>
    </form>
  );
}
